import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class HistoryStateService {

  private readonly KEY = 'navigation-state';

  save(state: any): void {
    sessionStorage.setItem(this.KEY, JSON.stringify(state));
  }

  get(): any {
    const data = sessionStorage.getItem(this.KEY);
    return data ? JSON.parse(data) : null;
  }

  clear(): void {
    sessionStorage.removeItem(this.KEY);
  }

getState(): any {
  const state = history.state;

  if (
    state &&
    !state.lock &&
    Object.keys(state).length > 1
  ) {
    return state;
  }

  const saved = sessionStorage.getItem('navigation-state');
  return saved ? JSON.parse(saved) : null;
}

}